import { render, staticRenderFns } from "./EditModalMessageTypeModal.vue?vue&type=template&id=2b7b82d4&scoped=true"
import script from "./EditModalMessageTypeModal.vue?vue&type=script&lang=js"
export * from "./EditModalMessageTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7b82d4",
  null
  
)

export default component.exports